import { render } from "./DestinationRow.vue?vue&type=template&id=5c1dc29f"
import script from "./DestinationRow.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationRow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/DestinationRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c1dc29f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c1dc29f', __exports__)) {
    api.reload('5c1dc29f', __exports__)
  }
  
  module.hot.accept("./DestinationRow.vue?vue&type=template&id=5c1dc29f", () => {
    api.rerender('5c1dc29f', render)
  })

}


export default __exports__